import {
  FC,
  ReactNode,
  RefObject,
  useEffect,
  useState,
} from 'react';
import classNames from 'classnames';
import { useStoryListContext } from '#advertStory/list';
import { STORY_DETAIL_LIST_DURATION } from '#advertStory/constants';
import { StoryDetailListTimelineItem } from '#advertStory/detail-list-timeline';
import { StoryDetailListDataType, StoryDetailListType } from '#advertStory/detail-list';
import storyTimelineCss from '../assets/story-timeline.module.scss';

type PropsType = {
  refStoryDetailList: RefObject<StoryDetailListType>,
  additionalClassName?: string;
};

const StoryDetailListTimeline: FC<PropsType> = ({
  refStoryDetailList,
  additionalClassName,
}) => {
  const { storyDataList } = useStoryListContext();
  const [storyDetailListData, setStoryDetailListData] = useState<StoryDetailListDataType>(null);

  useEffect(() => {
    const subscription = refStoryDetailList.current.dataSubject.subscribe(setStoryDetailListData);

    return () => {
      subscription.unsubscribe();
    };
  }, [refStoryDetailList]);

  if (storyDataList.length <= 1) {
    return null;
  }

  const timelineItemList = storyDataList.map((story, index): ReactNode => {
    const progress = storyDetailListData?.progress || 0;
    const progressInPercent = (progress / STORY_DETAIL_LIST_DURATION) * 100;

    return (
      <StoryDetailListTimelineItem
        key={story.id}
        activeIndex={storyDetailListData?.currentSlide || 0}
        currentIndex={index}
        progress={progressInPercent}
      />
    );
  });

  return (
    <div className={classNames(storyTimelineCss.storyTimeline, additionalClassName)}>
      {timelineItemList}
    </div>
  );
};

export { StoryDetailListTimeline };
